import { gql } from '@apollo/client';

export const GET_TAPE_LOAN_COUNT_QUERY = gql`
  query GetTapeLoanCount($filters: [Filter!]) {
    user {
      id
      company {
        id
        performance_summary(filters: $filters) {
          loan_count
        }
      }
    }
  }
`;
